import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[typeahead]:not([autocomplete])'
})
export class AutoCompleteOffDirective implements OnInit, OnDestroy{

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

    ngOnInit(): void {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'autocomplete', 'off');
    }
    ngOnDestroy(): void {
        this.renderer.removeAttribute(this.elementRef.nativeElement, 'autocomplete');
    }



}
